import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getDriversReport } from '../../services/Reports';

function useGetDriversReport(fleetId: string, query: string): UseQueryResult<any> {
  return useQuery(
    ['report-drivers', fleetId, query],
    async (): Promise<any> => getDriversReport(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: false,
      refetchInterval: false,
    },
  );
}

export default useGetDriversReport;
